const unsafeChars = {
    '+': '-',
    '/': '_',
} as const;

const safeChars = {
    '-': '+',
    '_': '/',
} as const;

export const urlSafeBase64Encode = (str: string): string => {
  return btoa(str)
    .replace(/\+/g, unsafeChars['+'])
    .replace(/\//g, unsafeChars['/'])
    .replace(/=/g, ''); // 패딩 제거
};

export const urlSafeBase64Decode = (str: string): string => {
  // URL-safe 문자를 일반 base64 문자로 변환
  let normalizedStr = str
    .replace(/-/g, safeChars['-'])
    .replace(/_/g, safeChars['_']);
  
  // 패딩 추가 (4로 나누어 떨어지도록)
  const padding = normalizedStr.length % 4;
  if (padding > 0) {
    normalizedStr += '='.repeat(4 - padding);
  }
  
  return atob(normalizedStr);
};


export const tryUrlSafeBase64Decode = (str: string): string => {
  try {
    return urlSafeBase64Decode(str);
  } catch {
    return '';
  }
};